<template>
  <div class="strategys-area-content" v-loading="loading">
    <div class="head_body" style="padding-top: 10px;">
      <el-form ref="form" :model="filter" class="search_head" label-width="120px">
        <el-row :gutter="20" class="list-head">
          <el-col :span="5">
            <el-form-item :label="$t('lampStrategy.strategy_name')">
              <el-input v-model="filter.title" :placeholder="$t('lampStrategy.input_strategy_name')" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('lampStrategy.strategy_type')">
              <el-select
                clearable
                :placeholder="$t('lampStrategy.select_strategy_type')"
                v-model="filter.run_model"
                style="width: 100%"
              >
                <el-option key="all" :label="$t('control.all')" value=""></el-option>
                <el-option :key="1" :label="$t('lampStrategy.system_strategy')" :value="1"></el-option>
                <el-option :key="2" :label="$t('lampStrategy.offline_strategy')" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2" class="search-btn-box">
              <el-button type="primary" size="small" @click="headSearch"><svg-icon name="search"></svg-icon>{{$t('control.search')}}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="h_line"></div>
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>{{$t('control.add')}}</el-button
          >
        </div>
        <div class="group-tip">{{$t('lampStrategy.area_strategy_tip')}}</div>
      </div>
      <div class="h20"></div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="title" :label="$t('lampStrategy.strategy_name')" width="220"></el-table-column>
        <el-table-column prop="title" :label="$t('lampStrategy.strategy_type')">
          <template slot-scope="scope">
            {{modelType[scope.row.run_model]}}
          </template>
        </el-table-column>
        <el-table-column prop="lnglat" :label="$t('control.lng_lat')" width="260">
          <template slot-scope="scope">
            {{scope.row.longitude}}, {{scope.row.latitude}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('lampStrategy.sunset_time')">
          <template slot-scope="scope">
            {{scope.row.sunset_time}}<br/>
            <template v-if="scope.row.sunset">
              <!-- 提前 -->
              {{scope.row.sunset_offset?$t('lampStrategy.set_advance')+scope.row.sunset_offset+$t('control.minute'):$t('lampStrategy.no_set')}}
            </template>
            <template v-else>
              <!-- 延迟 -->
              {{scope.row.sunset_offset?$t('lampStrategy.set_delay')+scope.row.sunset_offset+$t('control.minute'):$t('lampStrategy.no_set')}}
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="open_light_time" :label="'【'+$t('concentrator.open_connect')+'】'+$t('control.time')" width="220"></el-table-column>
        <el-table-column :label="$t('lampStrategy.sunrise_time')">
          <template slot-scope="scope">
            {{scope.row.sunrise_time}}<br/>
            <template v-if="scope.row.sunrise">
              <!-- 提前 -->
              {{scope.row.sunrise_offset?$t('lampStrategy.set_advance')+scope.row.sunrise_offset+$t('control.minute'):$t('lampStrategy.no_set')}}
            </template>
            <template v-else>
              <!-- 延迟 -->
              {{scope.row.sunrise_offset?$t('lampStrategy.set_delay')+scope.row.sunrise_offset+$t('control.minute'):$t('lampStrategy.no_set')}}
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="close_light_time" :label="'【'+$t('concentrator.close_break')+'】'+$t('control.time')" width="220"></el-table-column>
        <el-table-column prop="edit" :label="$t('control.operate')" width="140">
          <template slot-scope="scope">
            <div class="table-last">
              <span @click="openEditWin(scope.row)" class="blue pointer mar-r10">{{$t('control.edit')}}</span>
              <span @click="delItem(scope.row.id)" class="blue pointer">{{$t('control.delete')}}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>
    

    <!--新增修改路灯策略 开始-->
    <el-dialog
      v-if="dialogVisible"
      class="dialog860"
      :title="editType === 'create' ? $t('lampStrategy.add_area_strategy') : $t('lampStrategy.edit_area_strategy')"
      :visible.sync="dialogVisible"
      
    >
      <el-form
        :model="editOne"
        ref="editOneRef"
        label-position="left"
        :rules="editOneRule"
        :label-width="$i18n.locale==='zh-CN'?'100px':'120px'"
      >
        <div class="form-info">
          <el-row :gutter="20" class="item-list">
            <el-col :span="12">
              <el-form-item :label="$t('lampStrategy.strategy_name')" prop="title">
                <el-input v-model="editOne.title" :placeholder="$t('lampStrategy.input_strategy_name')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('lampStrategy.strategy_type')">
                <el-select
                  :placeholder="$t('lampStrategy.strategy_type')"
                  v-model="editOne.run_model"
                  style="width: 100%"
                  :disabled="editType === 'create'?false:true"
                >
                  <el-option :key="1" :label="$t('lampStrategy.system_strategy')" :value="1"></el-option>
                  <el-option :key="2" :label="$t('lampStrategy.offline_strategy')" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('control.longitude')" prop="longitude">
                <el-input v-model="editOne.longitude" :placeholder="$t('lampStrategy.enter_lng')"></el-input>
              </el-form-item>
              <el-form-item :label="$t('control.latitude')" prop="latitude">
                <el-input v-model="editOne.latitude" :placeholder="$t('lampStrategy.enter_lat')"></el-input>
              </el-form-item>
              <div class="form-time-box">
                <span class="label">{{$t('concentrator.expect')}}【{{$t('concentrator.open_connect')}}】{{$t('control.time')}}</span>
                <el-time-picker
                  :clearable="false"
                  class="area-input"
                  format='HH:mm'
                  @change="changeTime(1)"
                  v-model="editOne.open_light_time"
                  :picker-options="{
                    selectableRange: editOne.sunset_rang,
                  }"
                  :placeholder="$t('lampStrategy.enter_open_time')">
                </el-time-picker>
                <div v-if="editOne.sunset_delay>0"  class="time">{{$t('lampStrategy.delay')}}{{parseInt(editOne.sunset_delay)}}{{$t('control.minute')}}</div>
                <div v-if="editOne.sunset_delay<0"  class="time">{{$t('lampStrategy.advance')}}{{parseInt(editOne.sunset_delay)*-1}}{{$t('control.minute')}}</div>
              </div>
              <div class="form-time-box">
                <span class="label">{{$t('concentrator.expect')}}【{{$t('concentrator.close_break')}}】{{$t('control.time')}}</span>
                <el-time-picker
                  :clearable="false"
                  class="area-input"
                  format='HH:mm'
                  @change="changeTime(0)"
                  v-model="editOne.close_light_time"
                  :picker-options="{
                    selectableRange: editOne.sunrise_rang,
                  }"
                  :placeholder="$t('lampStrategy.enter_close_time')">
                </el-time-picker>
                <div v-if="editOne.sunrise_delay>0" class="time" >{{$t('lampStrategy.delay')}}{{parseInt(editOne.sunrise_delay)}}{{$t('control.minute')}}</div>
                <div v-if="editOne.sunrise_delay<0" class="time">{{$t('lampStrategy.advance')}}{{parseInt(editOne.sunrise_delay)*-1}}{{$t('control.minute')}}</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="map-box">
                <area-map :nowlng="editOne.longitude" :nowlat="editOne.latitude" @mapDing="getCoordinate" />
              </div>
            </el-col>
          </el-row>

          <div class="lamp-transfer strategy-area-transfer">
            <el-transfer
              filterable
              :filter-placeholder="$t('concentrator.input_device_name')"
              :data="allDevices"
              :titles="[$t('concentrator.device_can'), $t('concentrator.device_have')]"
              :button-texts="[$t('control.remove'), $t('control.add')]"
              v-model="allocated"
            >
            </el-transfer>
          </div>

        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div class="box-footer">
          <el-button class="cancel-btn" size="medium" @click="dialogVisible = false">{{$t('control.cancel')}}</el-button>
          <el-button type="primary" size="medium" @click="verifyItem()">{{$t('control.confirm')}}</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 新增修改路灯策略 结束 -->
  </div>
</template>
<script>
import commonJs from '@/utils/common'
import time from "@/utils/time";
import moment from "moment";
import strategyApi from "@/api/concentrator/strategy"
import areaMap from '@/components/areaMap'
export default {
  name: "strategyArea",
  components: {
    areaMap
  },
  data() {
    return {
      loading: false,
      tableData: [],
      modelType: this.$t('lampStrategy.modelType'),
      pageInfo: {
        filter: '',
        page: 1,
        pageSize: 20
      },
      filter: {
        strategy_type: 2,
        title: '',
        run_model: ''
      },
      cnt_all: 0,
      dialogVisible: false,
      editOneRule: {
        title: [{ required: true, message: this.$t('lampStrategy.input_strategy_name'), trigger: "blur" }],
        longitude: [{ required: true, message: this.$t('control.longitude'), trigger: "blur" }],
        latitude: [{ required: true, message: this.$t('control.latitude'), trigger: "blur" }],
      },
      editType: -1,
      editOne: {
        id: '',
        title: '',
        run_model: 1,
        strategy_type: 2,
        longitude: '',
        latitude: '',
        sunset_time: '',
        sunrise_time: '',
        open_light_time: '',
        close_light_time: '',
        sunset_delay: 0,
        sunrise_delay: 0,
        sunset_rang: '00:00-24:00',
        sunrise_rang: '00:00-24:00'
      },
      allDevices: [],
      allocated: []
    };
  },
  methods: {
    ...time,
    getTableData(pageIndex) {
      this.tableData = []
      this.pageInfo.filter = ''
      this.loading = true;
      this.pageInfo.page = pageIndex;
      let filter = this.filter;
      filter = filter && commonJs.obj.removeNullKey(filter);
      if (filter && Object.keys(filter).length) {
        this.pageInfo.filter = JSON.stringify(filter);
      }
      strategyApi.strategyList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      })
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    headSearch() {
      this.pageInfo.page = 1
      this.pageInfo.pageSize = 20
      this.getTableData(1)
    },
    openEditWin(index) {
      this.allDevices = []
      this.allocated = []
      if (index === "create") {
        if(this.cnt_all&&this.$store.state.user.role_type!=1){
          return this.$message.error(this.$t('lampStrategy.area_strategy_must1'))
        }
        this.editOne = {
          id: '',
          title: '',
          run_model: 1,
          strategy_type: 2,
          longitude: '',
          latitude: '',
          sunrise_light: 0, // 日出亮度0
          sunset_time: 0,
          sunrise_time: 0,
          open_light_time: '',
          close_light_time: '',
          sunset_delay: 0,
          sunrise_delay: 0,
          sunset_rang: '00:00-24:00',
          sunrise_rang: '00:00-24:00'
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          title: index.title,
          run_model: index.run_model,
          strategy_type: 2,
          longitude: index.longitude,
          latitude: index.latitude,
          sunset_time: index.sunset_time, // 日落
          sunrise_time: index.sunrise_time, //日出
          open_light_time: this.numberToTime(this.HmToNumber(index.open_light_time)), // picker插件需要日期格式
          close_light_time: this.numberToTime(this.HmToNumber(index.close_light_time)), // picker插件需要日期格式
          sunset_delay: (this.HmToNumber(index.open_light_time) - this.HmToNumber(index.sunset_time))/60, // 日落开延迟或提前
          sunrise_delay: (this.HmToNumber(index.close_light_time) - this.HmToNumber(index.sunrise_time))/60, //日出开延迟或提前
          sunrise_light: index.sunrise_light, // 日出 （关）亮度0、（保留功能，可能有的不会关为0）
          sunset_rang: '00:00-24:00', //日落开选择的范围（初始） 下面this.setTimeRang()根据日落（sunset_time）设定范围
          sunrise_rang: '00:00-24:00' //日出关选择的范围（初始） 下面this.setTimeRang()根据日出（sunrise_time）设定范围
        };
        // console.log('this.editOne', this.editOne)

        this.setTimeRang()
        this.editType = "update";
      }
      this.dialogVisible = true;
      this.loading = false;
      this.getDeviceList(0);
    },
    verifyItem(){
      const { title, run_model, longitude, latitude, open_light_time, close_light_time } = this.editOne;
      if(!title){
        return this.$message.error(this.$t('lampStrategy.area_from_tip1'))
      }
      if(!run_model){
        return this.$message.error(this.$t('lampStrategy.area_from_tip2'))
      }
      if(!longitude||!latitude){
        return this.$message.error(this.$t('lampStrategy.area_from_tip3'))
      }

      if(!open_light_time){
        return this.$message.error(this.$t('lampStrategy.area_from_tip4'))
      }
      if(!close_light_time){
        return this.$message.error(this.$t('lampStrategy.area_from_tip5'))
      }

      let params = {
        title: title,
        run_model: run_model,
        strategy_type: 2,
        longitude: longitude,
        latitude: latitude,
        open_light_time: moment(open_light_time).format("HH:mm"),
        close_light_time: moment(close_light_time).format("HH:mm"),
        ids: ''
      }
      
      if(this.allocated.length){
        params.ids=this.allocated.toString();
      }
      if(this.editType == "create"){
        this.createItem(params)
      }else{
        this.updateItem(params)
      }
    },
    createItem(params) {
      this.$refs.editOneRef.validate((valid) => {
        if (valid) {
          strategyApi.strategyAdd(params).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.add_success'));
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          })
        } else {
          return false
        }
      })
    },
    updateItem(params) {
      this.$refs.editOneRef.validate((valid) => {
        if (valid) {
          strategyApi.strategyEdit(this.editOne.id,params).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.mod_success'))
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message)
            }
          })
        } else {
          return false
        }
      })
    },
    getDeviceList(id) {
      let that = this
      strategyApi.getConcentratorByStrategyId(id).then((res) => {
        if (res.data.code === 1000) {
          let arrData = []
          let resData = res.data.data
          if(resData.length){
            for (const device of resData) {
              arrData.push({
                key: device.id,
                label: device.name
              })
            }
          }
          that.allocated = []
          if(id){
            if(arrData.length){
              for (const item of arrData) {
                that.allocated.push(item.key)
              }
              that.allDevices = [...that.allDevices, ...arrData]
              that.allDevices = Array.from(new Set(that.allDevices))
            }
          }else{
            that.allDevices = arrData
            if(that.editOne.id){
              that.getDeviceList(that.editOne.id)
            }
          }
        }
      })
    },

    delItem(id) {
      this.$confirm(this.$t('control.tip_del_data_title'), this.$t('control.tip'), {
        confirmButtonText: this.$t('control.confirm'),
        cancelButtonText: this.$t('control.cancel'),
        type: "warning",
      })
      .then(() => {
        strategyApi.strategyDel(id).then((res) => {
          if (res.data.code === 1000) {
            this.$popupMessage({
              type: 'success',
              title: this.$t('control.del_success')
              // msg: '如果未刷新，请耐心等待5秒，点击刷新列表查看结果'
            })
            this.getTableData(this.pageInfo.page);
          } else {
            this.$popupMessage({
              type: 'error',
              title: this.$t('control.tip'),
              msg: res.data.message,
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: this.$t('control.cancel_del'),
        });
      });
    },
    getCoordinate(map) {
      let that = this
      that.editOne.longitude = map.lng
      that.editOne.latitude = map.lat
      strategyApi.getDateSunInfo({
        longitude: map.lng,
        latitude: map.lat,
      }).then((res) => {
        if (res.data.code === 1000) {
          if(res.data.data.sunset_time!=that.editOne.sunset_time){
            that.editOne.sunset_delay = 0
            that.editOne.sunrise_delay = 0

            that.editOne.sunset_time = res.data.data.sunset_time
            that.editOne.open_light_time = that.numberToTime(that.HmToNumber(res.data.data.sunset_time))
            that.editOne.sunrise_time = res.data.data.sunrise_time
            that.editOne.close_light_time = that.numberToTime(that.HmToNumber(res.data.data.sunrise_time))
            that.setTimeRang()
          }
        }
      })
    },
    setTimeRang(){ // 设置 时间范围
      let maxTimeSunset_time =  moment(this.numberToTime(this.HmToNumber(this.editOne.sunset_time)+3600)).format("HH:mm");
      let minTimeSunset_time =  moment(this.numberToTime(this.HmToNumber(this.editOne.sunset_time)-3600)).format("HH:mm")
      let maxTimeSunrise_time =  moment(this.numberToTime(this.HmToNumber(this.editOne.sunrise_time)+3600)).format("HH:mm")
      let minTimeSunrise_time =  moment(this.numberToTime(this.HmToNumber(this.editOne.sunrise_time)-3600)).format("HH:mm")
      this.editOne.sunset_rang = minTimeSunset_time+':00-'+maxTimeSunset_time+':00'
      this.editOne.sunrise_rang = minTimeSunrise_time+':00-'+maxTimeSunrise_time+':00'
    },
    changeTime(type){ //1 预计开时间， 0预计关时间
      if(type==1){
        let  sunset_times = this.editOne.sunset_time // 日落时间
        let  open_light_times = this.editOne.open_light_time // 日落开时间
        this.editOne.sunset_delay = (this.HmToNumber(moment(open_light_times).format("HH:mm")) - this.HmToNumber(sunset_times))/60 //分钟
      }else{
        let  sunrise_times = this.editOne.sunrise_time // 日出时间
        let  close_light_times = this.editOne.close_light_time // 日出关时间
        this.editOne.sunrise_delay = (this.HmToNumber(moment(close_light_times).format("HH:mm")) - this.HmToNumber(sunrise_times))/60 //分钟
      }
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page)
  },
};
</script>

<style lang='less'>
.strategys-area-content{
  padding:0 0 20px;
  .con-body{
    padding:20px 0 10px !important;
  }
  .form-time-box{
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    span.label{
      margin-right: 20px;
      color: #1d2129;
    }
    .area-input,.yellow-slider{
      flex: 1;
      min-width:100px;
    }
    .area-input{
      flex: 1;
      .el-input__prefix{
        left: auto !important;
        right:10px !important;
        font-size: 16px;
        top:2px;
      }
      .el-input__inner{
        padding-left: 20px !important;
      }
    }
    .time,.number{
      color:#e7542f;
      font-size: 13px;
      margin-left: 20px;
    }
    .number{
      font-size: 14px;
      color: #1d2129;
    }
  }
  .map-box{
    padding: 0 !important;
  }
  .strategy-area-transfer{
    margin-top:20px;
    padding-top: 30px;
    border-top:1px solid #dcdee2;
    .el-transfer__buttons{
      .el-transfer__button{
        left:100px !important;
        &:first-child{
          left: auto !important;
          right:100px !important;
        }
      }
    }
  }
  .form-info{
    .el-form-item__label{
      width:85px;
    }
  }
}
</style>
